let files = [];
const max_files = 10;
let saving_retailers = false;

$('.retailers_form button[type=button]').on('click', function(e) {
    e.preventDefault();
    $('.retailers_form input[type=file]').click();
});

$('.retailers_form input[type=file]').on('change', function(e) {
    if (e.currentTarget.files.length > 0) {
        $.each(e.currentTarget.files,function(k,v){
            if (files.length <= max_files) files.push(v);
        });

        renderFiles();
    }
});

$('.retailers_form').on('click', '.files_row a', function(e) {
    e.preventDefault();
    const index = $(this).closest('.files_row').data('id');
    files.splice(index, 1);
    renderFiles();
});

$('.retailers_form').on('submit', function(e) {
    e.preventDefault();

    if (!saving_retailers) {
        saving_retailers = true;
        
        let fileData = new FormData(this);
        for (let i = 0; i < files.length; i++) {
            fileData.append("file_" + i, files[i]);
        }

        $.ajax({
            url: 'https://cdn.byparra.com/send_retailers.php',
            method:'POST',
            data: fileData,
            dataType: 'JSON',
            cache: false,
            contentType: false,
            processData: false,
            success: function(res) {
                saving_retailers = false;
                if (res.success) {
                    files = [];
                    $('.retailers_form')[0].reset();
                    renderFiles();
                    $('.retailers_form button[type=submit]').addClass('send').html('Sent');
                }
            },
            error : function(res) { 
                saving_retailers = false;
                console.log(res);
            }
        })
    }
});

const renderFiles = () => {
    $('.retailers_form .files_row:not(.files_row--empty)').remove();
    if (files.length > 0) {
        $('.retailers_form .files_row--empty').hide();
        $.each(files, function(k, v) {
            $("<div class='files_row' data-id='" + k + "'><span>" + v.name.toLowerCase() + "</span><a href='#'></a></div>").insertBefore('.retailers_form .files_row--empty');
        })
    } else {
        $('.retailers_form .files_row--empty').show();
    }

    if (files.length === max_files) {
        $('.retailers_form button[type=button]').attr('disabled', true);
    } else {
        $('.retailers_form button[type=button]').attr('disabled', false);
    }
}